import React from "react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { ausgangslage: a } = content;

export const Ausgangslage = () => (
  <Section id="ausgangslage" testId="section-ausgangslage" className="has-lines overflow-hidden">
    <FlowLines color="#0F9D6E" opacity={[0.035, 0.028]} />
    <Container>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <Reveal>
          <Label>{a.label}</Label>
          <AccentH2 className="mt-7 max-w-[440px] text-3xl font-bold text-[#1e2532] md:text-[44px]">{a.h2}</AccentH2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="max-w-[640px] text-[17px] leading-[1.8] text-[#565f70] md:text-[18px]">{a.intro}</p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-px border-t border-[#dfe2e0] md:mt-20 md:grid-cols-2">
        {a.cards.map((c, i) => (
          <Reveal key={c.h3} delay={(i % 2) * 0.09}>
            <article
              data-testid={`ausgangslage-card-${i}`}
              className="card-hover h-full border-b border-[#dfe2e0] p-8 md:border-r md:p-10"
            >
              <span className="font-display text-[13px] font-bold tracking-[0.14em] text-[#0f9d6e]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-6 text-xl font-semibold text-[#1e2532] md:text-[22px]">{c.h3}</h3>
              <p className="mt-4 text-[16px] leading-[1.76] text-[#565f70]">{c.text}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p
          data-testid="ausgangslage-closing"
          className="mt-14 max-w-[820px] border-l-2 border-[#0f9d6e] pl-7 font-display text-[22px] font-medium leading-[1.42] text-[#1e2532] md:text-[28px]"
        >
          {a.closing}
        </p>
      </Reveal>
    </Container>
  </Section>
);
